// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".query-editor-custom-icon-button-container{width:30px;height:30px;flex-shrink:0;flex-grow:0;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;outline:none;border:1px solid rgba(0,0,0,.12)}.query-editor-custom-icon-button-container svg{width:90%;height:90%}.query-editor-custom-icon-button-container:hover{box-shadow:0 0 8px 4px rgba(0,0,0,.12);border-color:rgba(0,0,0,0)}", ""]);
// Exports
module.exports = exports;
